import { useNavigate } from "react-router-dom";
import { Images } from "../../../Controller";
import DashboardCommon from "../Dashboard/DashboardCommon";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setselectedTab } from "../../../Store/B2bslice";

const PaymentService = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const checkDigiStatus = () => {
    if (
      profiledetail.digio_kyc === "0" ||
      profiledetail.digio_kyc === "2" ||
      profiledetail.digio_kyc === "3"
    ) {
      return true;
    }
  };
  useEffect(() => {
    dispatch(setselectedTab("4"));
  }, []);
  return (
    <>
      <div className="m-4">
        {" "}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3  place-items-start gap-3">
          {/* <div
            className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 w-full rounded-xl cursor-pointer"
            onClick={() =>
              navigate(
                memberServices.includes("101")
                  ? "/eko/payout"
                  : memberServices.includes("5")
                  ? checkDigiStatus()
                    ? "/kycStatus"
                    : "/payout/verification"
                  : "/not-available"
              )
            }
          >
            <img
              src={Images.cashDeposit}
              className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
              alt="DMT"
            />
            <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
              Payout
            </p>
          </div> */}
          {(memberServices.includes("102") ||
            memberServices.includes("120") ||
            memberServices.includes("9")) && (
            <div
              className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 w-full rounded-xl cursor-pointer"
              onClick={() =>
                navigate(
                  memberServices.includes("102")
                    ? "/eko/express-payout"
                    : memberServices.includes("9")
                      ? checkDigiStatus()
                        ? "/kycStatus"
                        : "/express-payout/get_remitter"
                      : memberServices.includes("120")
                        ? "/pay-fusion-express-payout/get_remitter"
                        : "/not-available",
                )
              }
            >
              <img
                src={Images.DMT}
                className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
                alt="DMT"
              />
              <p className="text-rgbaprimary7 text-base leading-5 font-bold p-2">
                Payments
              </p>
            </div>
          )}
          {memberServices.includes("122") && (
            <div
              className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 w-full rounded-xl cursor-pointer"
              onClick={() =>
                navigate(
                  memberServices.includes("122")
                    ? "/pay-fusion/upiPayout"
                    : "/not-available",
                )
              }
            >
              <img
                src={Images.DMT}
                className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
                alt="DMT"
              />
              <p className="text-rgbaprimary7 text-base leading-5 font-bold p-2">
                UPI Payments
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PaymentService;
